export const tabsSelectors = {
  getActiveTab: state => state.tabs.activeTab,
};
